'use client';
import { useEffect } from 'react';
import { GameFilter } from '@/widgets/game-filter';
import { GameSections } from '@/widgets/game-sections';
import { NotAlowedModal } from '@/entities/game/ui/not-alowed-modal';
import { Layout } from '@/shared/ui/layouts';
import { TitleH1, Wrapper } from './styles';
import { News } from '@/features/news-managment';
import { useVisibleState } from '@/shared/hooks';
import { CashbackModal } from '@/entities/cashback/ui/cashback-modal';
import { useI18n } from '@locales/client';
import { useRouter, useSearchParams, useParams } from 'next/navigation';
import Cookies from 'js-cookie';
import { Condition } from '@/shared/ui/condition';
import { useUser } from '@/shared/providers/user-provider/use-user';
import { Banners } from '@/entities/minibanner/ui/banners';
import { withBreakpointsSlice } from '@/shared/providers/utils/with-breakpoints-slice';
import { useAuthorization } from '@/entities/session';
// import { saveUTMParamsToCookies } from '@/shared/libs/saveUTMParamsToCookies';
import AuthButtons from '@/shared/ui/auth-buttons/AuthButtons';
import { H1_HeadingBoldH1 } from '@/shared/ui/typography2';

// const PWAPrompt = dynamic(() => import('react-ios-pwa-prompt'), { ssr: false });
const Home = ({ isGames, mobileLandscape }) => {
  const searchParams = useSearchParams();
  const params = useParams();
  const isPlayGame = Boolean(params?.titleGame);
  const t = useI18n();
  const {
    open: openNotAlowedModal,
    visible: visibleNotAlowedModal,
    close: closeNotAlowedModal,
  } = useVisibleState(false);

  const {
    open: openCashbackModal,
    visible: visibleCashbackModal,
    close: closeCashbackModal,
  } = useVisibleState(false);

  const { authenticate } = useAuthorization();

  const { user } = useUser();
  const router = useRouter();

  useEffect(() => {
    // saveUTMParamsToCookies(searchParams);

    const tokenParams = searchParams.get('token');
    if (tokenParams) {
      authenticate(
        {
          token: tokenParams,
        },
        'loginWithToken'
      );
    }
  }, [searchParams]);

  // useEffect(() => {
  //   const handleBeforeInstallPrompt = (event) => {
  //     event.preventDefault();
  //     setDeferredPrompt(event);
  //     setIsInstallable(true);
  //   };

  //   window.addEventListener('beforeinstallprompt', handleBeforeInstallPrompt);

  //   return () => {
  //     window.removeEventListener(
  //       'beforeinstallprompt',
  //       handleBeforeInstallPrompt
  //     );
  //   };
  // }, []);

  useEffect(() => {
    const tgWebAppStartParam = searchParams.get('tgWebAppStartParam');
    const modalSearchParam = searchParams.get('modal');
    if (modalSearchParam === 'cashback') {
      openCashbackModal();
    }
    if (tgWebAppStartParam) {
      const params = tgWebAppStartParam.split('_');
      const token = params[0];
      const page = params[1];
      const args = params.slice(2);

      if (token) {
        Cookies.set('sessionId', token, { expires: 7 });
      }

      switch (page) {
        case 'deposit':
          router.push('/?deposit=1');
          break;
        case 'withdraw':
          router.push('/?withdraw=1');
          break;
        case isPlayGame:
          // TODO поправить, нужен кейс, так как роут изменился

          // const gameID = args[0] || '';
          // const demoMode = args[1] === 'true' ? 'true' : 'false';
          // router.push(`/games/${gameID}?demo=${demoMode}`);
          break;
        case 'profile':
          router.push('/profile');
          break;
        case 'bonuses':
          router.push('/bonuses');
          break;
        default:
          router.push('/');
          break;
      }
    }
  }, [searchParams]);

  // const handleInstallClick = async () => {
  //   if (deferredPrompt) {
  //     deferredPrompt.prompt();
  //     const choiceResult = await deferredPrompt.userChoice;
  //     if (choiceResult.outcome === 'accepted') {
  //       console.log('PWA установка подтверждена пользователем');
  //     } else {
  //       console.log('Пользователь отклонил установку PWA');
  //     }
  //     setDeferredPrompt(null);
  //     setIsInstallable(false);
  //   }
  // };

  // const detectPlatform = () => {
  //   const userAgent = window.navigator.userAgent || window.opera;

  //   if (/android/i.test(userAgent)) {
  //     return 'Android';
  //   }

  //   if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
  //     return 'iOS';
  //   }

  //   return 'Unknown';
  // };

  return (
    <>
      <Wrapper>
        <Layout>
          <Condition match={!user.isAuth}>
            <AuthButtons />
            {!isGames && (
              <TitleH1>
                <H1_HeadingBoldH1>{t('home.title')}</H1_HeadingBoldH1>
              </TitleH1>
            )}
          </Condition>
          {/* {mobileLandscape && isGames && <SearchGame />} */}

          {!isGames && <News openCashbackModal={openCashbackModal} />}

          <Banners isGames={isGames} />

          {isGames && <GameFilter />}

          <GameSections
            isGames={isGames}
            openNotAlowedModal={openNotAlowedModal}
            visibleNotAlowedModal={visibleNotAlowedModal}
            closeNotAlowedModal={closeNotAlowedModal}
          />
          <NotAlowedModal
            visible={visibleNotAlowedModal}
            onClose={closeNotAlowedModal}
            onOpen={openNotAlowedModal}
          />
        </Layout>
        <CashbackModal
          visible={visibleCashbackModal}
          onClose={() => {
            closeCashbackModal();
            router.push('/');
          }}
        />
      </Wrapper>
    </>
  );
};

const HomeWithBreakpointsSlice = withBreakpointsSlice(
  Home,
  ({ mobileLandscape }) => ({
    mobileLandscape,
  })
);
export { HomeWithBreakpointsSlice as Home };
